import React from 'react';

import './button-primary.scss';

interface ButtonPrimaryProps {
  children: React.ReactNode;
  className?: string;
  [x: string]: unknown;
}

export default function ButtonPrimary({ children, className, ...props }: ButtonPrimaryProps) {
  return (
    <div className="button-primary">
      <button
        {...props}
        className={`button-text button is-rounded is-fullwidth content-normal ${
          className ? className : ''
        }`}
      >
        {children}
      </button>
    </div>
  );
}
